// src/components/common/Footer/Footer.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import { REQUISITES } from '../../../utils/requisites.js';

export const Footer = () => {
  const columns = [
    {
      title: 'Каталог',
      links: [
        { label: 'Буквы', path: '/catalog/letters' },
        { label: 'Декор', path: '/catalog/decor' },
        { label: 'Вывески', path: '/catalog/signs' },
        { label: 'Услуги', path: '/services' },
        { label: 'Пакеты', path: '/packages' },
      ],
    },
    {
      title: 'О нас',
      links: [
        { label: 'О компании', path: '/about' },
        { label: 'Кейсы', path: '/cases' },
        { label: 'Блог', path: '/blog' },
        { label: 'Академия', path: '/academy' },
        { label: 'Партнерам', path: '/partners' },
      ],
    },
    {
      title: 'Поддержка',
      links: [
        { label: 'Помощь', path: '/help' },
        { label: 'Поддержка', path: '/support' },
        { label: 'Доставка и оплата', path: '/delivery' },
        { label: 'Возврат', path: '/returns' },
      ],
    },
    {
      title: 'Контакты',
      links: [
        { label: REQUISITES.phone, path: REQUISITES.phoneHref },
        // ⚠️ Домен изменён 2026-10-07: было `info@studio-reklama.ru`.
        //    Проверено замером: у `studio-reklama.ru` НЕТ A-записи — домен
        //    не существует вовсе. Наш домен — `reklama-oskol.ru` (он есть).
        //    Почта на нём ещё НЕ настроена (MX-записи нет) — см. техдолг.
        { label: REQUISITES.email, path: `mailto:${REQUISITES.email}` },
        { label: REQUISITES.city, path: '/contacts' },
      ],
    },
  ];

  return (
    <footer className="bg-[#17191d] pt-16 pb-8 text-bg font-[Inter,Manrope,Arial,sans-serif] mt-5">
      <div className="mx-auto max-w-[1240px] px-4">
        
        {/* Основная сетка ссылок */}
        <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-4 pb-10 border-b border-line/10">
          {columns.map((column, index) => (
            <div key={index}>
              <h4 className="text-sm font-medium uppercase tracking-[.1em] text-accent mb-4">
                {column.title}
              </h4>
              <ul className="flex flex-col gap-2.5">
                {column.links.map((link, i) => (
                  <li key={i}>
                    <Link
                      to={link.path}
                      className="text-xs font-light text-subtle transition-colors hover:text-white"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* 🔑 РЕКВИЗИТЫ ПРОДАВЦА — ОБЯЗАТЕЛЬНЫ, ЭТО НЕ УКРАШЕНИЕ.
            Ст. 9 Закона «О защите прав потребителей» и п. 4 Правил продажи
            товаров по договору розничной купли-продажи (ПП РФ № 2463) требуют
            указывать полное имя продавца, ОГРНИП и адрес — ДО заключения
            договора, то есть на самом сайте.

            ⚠️ ДАННЫЕ ВЗЯТЫ ИЗ ЕГРИП, А НЕ ВЫДУМАНЫ (проверено 2026-10-07):
               ИП Цар Владимир Олегович, ИНН 312822609298,
               ОГРНИП 315312800004651 от 14.05.2015,
               УФНС по Белгородской области.
            ⚠️ Юридический адрес в ЕГРИП указан как «Белгородская область,
               город Старый Оскол» — БЕЗ улицы и дома (регистр не публикует
               детали). Поэтому здесь только город: выдумывать улицу нельзя.
            🔴 ПРОВЕРИТЬ У ЮРИСТА: при НПД (самозанятость) вместо ОГРНИП
               указывают статус плательщика НПД. См. SHOP_ROADMAP.txt §7. */}
        <div className="border-t border-line/10 pt-6 pb-2 text-xs font-light text-subtle">
          <p className="leading-relaxed">
            <span className="text-subtle">Продавец:</span>{' '}
            {REQUISITES.legalName}
            {' · '}ИНН {REQUISITES.inn}
            {' · '}ОГРНИП {REQUISITES.ogrnip}
            {' · '}{REQUISITES.region}, {REQUISITES.city}
          </p>
          <p className="mt-1.5 leading-relaxed">
            <span className="text-subtle">Обращения:</span>{' '}
            {REQUISITES.phone}, {REQUISITES.email}
          </p>
        </div>

        {/* Нижняя строка с копирайтом и политиками */}
        <div className="flex flex-wrap items-center justify-between gap-4 pt-6 text-xs font-light text-subtle">
          <p>© 2026 Студия Рекламы. Все права защищены</p>
          
          <div className="flex flex-wrap gap-6">
            <Link to="/privacy" className="transition-colors hover:text-white">
              Политика конфиденциальности
            </Link>
            <Link to="/terms" className="transition-colors hover:text-white">
              Публичная оферта
            </Link>
          </div>
        </div>

      </div>
    </footer>
  );
};